/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccidentVehicleDto } from '../models/AccidentVehicleDto';
import type { AccidentVehiclePaymentInput } from '../models/AccidentVehiclePaymentInput';
import type { AccidentVehiclePaymentsDto } from '../models/AccidentVehiclePaymentsDto';
import type { CloseVehicleAccidentModel } from '../models/CloseVehicleAccidentModel';
import type { EditVehicleAccidentModel } from '../models/EditVehicleAccidentModel';
import type { SetAccidentPaymentScheduleModel } from '../models/SetAccidentPaymentScheduleModel';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { UserResultDto } from '../models/UserResultDto';
import type { VehicleAccidentDto } from '../models/VehicleAccidentDto';
import type { VehicleAccidentDtoPagedListData } from '../models/VehicleAccidentDtoPagedListData';
import type { VehicleAccidentManagerNoteDto } from '../models/VehicleAccidentManagerNoteDto';
import type { VehicleAccidentNoteInput } from '../models/VehicleAccidentNoteInput';
import type { VehicleAccidentPaymentStatusEnum } from '../models/VehicleAccidentPaymentStatusEnum';
import type { VehicleAccidentRepairStatusEnum } from '../models/VehicleAccidentRepairStatusEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VehicleAccidentService {

  /**
   * @param ids 
   * @param dateFrom 
   * @param dateTo 
   * @param regNStock 
   * @param managerId 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param paymentStatus
 *
 * 0 = Complete
 *
 * 1 = Pending
   * @param repairStatus
 *
 * 1 = AwaitingForAuthorization
 *
 * 2 = InProgress
 *
 * 3 = PartsInOrder
 *
 * 4 = Done
   * @param isClosed 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns VehicleAccidentDtoPagedListData Success
   * @throws ApiError
   */
  public static getVehicleAccident(
ids?: Array<number>,
dateFrom?: string,
dateTo?: string,
regNStock?: string,
managerId?: number,
sort?: string,
order?: SortTypeEnum,
paymentStatus?: VehicleAccidentPaymentStatusEnum,
repairStatus?: VehicleAccidentRepairStatusEnum,
isClosed?: boolean,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<VehicleAccidentDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident',
      query: {
        'Ids': ids,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RegNStock': regNStock,
        'ManagerId': managerId,
        'Sort': sort,
        'Order': order,
        'PaymentStatus': paymentStatus,
        'RepairStatus': repairStatus,
        'IsClosed': isClosed,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postVehicleAccident(
formData?: {
AccidentDate: string;
PersonInvolvedId: number;
FirstCarInvolvedStockId?: number;
AccidentDescription?: string;
ThirdPartyVehicleInvolved: boolean;
ThirdPartyVehicleDetails?: string;
ThirdPartyDriverDetails?: string;
ManagerId: number;
CostToRepair: number;
RegNo?: string;
StockNo?: string;
Photos?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-accident',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns VehicleAccidentDto Success
   * @throws ApiError
   */
  public static getVehicleAccident1(
id: number,
): CancelablePromise<VehicleAccidentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns EditVehicleAccidentModel Success
   * @throws ApiError
   */
  public static putVehicleAccident(
id: number,
formData?: {
RepairStatus?: VehicleAccidentRepairStatusEnum;
CostToRepair?: number;
AccidentDescription?: string;
ThirdPartyVehicleDetails?: string;
ThirdPartyDriverDetails?: string;
FirstCarInvolvedStockId?: number;
ManagerId?: number;
NewPhotos?: Array<Blob>;
DeletePhotos?: Array<number>;
},
): CancelablePromise<EditVehicleAccidentModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-accident/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVehicleAccident(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-accident/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param isClosed 
   * @returns CloseVehicleAccidentModel Success
   * @throws ApiError
   */
  public static putVehicleAccidentClose(
id: number,
isClosed?: boolean,
): CancelablePromise<CloseVehicleAccidentModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-accident/{id}/close',
      path: {
        'id': id,
      },
      query: {
        'isClosed': isClosed,
      },
    });
  }

  /**
   * @param id 
   * @returns VehicleAccidentManagerNoteDto Success
   * @throws ApiError
   */
  public static getVehicleAccidentManagerNotes(
id: number,
): CancelablePromise<Array<VehicleAccidentManagerNoteDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident/{id}/manager-notes',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postVehicleAccidentManagerNotes(
id: number,
requestBody?: VehicleAccidentNoteInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-accident/{id}/manager-notes',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns AccidentVehiclePaymentsDto Success
   * @throws ApiError
   */
  public static getVehicleAccidentPayments(
id: number,
): CancelablePromise<Array<AccidentVehiclePaymentsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident/{id}/payments',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postVehicleAccidentPayments(
id: number,
requestBody?: AccidentVehiclePaymentInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-accident/{id}/payments',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVehicleAccidentPaymentSchedule(
id: number,
requestBody?: SetAccidentPaymentScheduleModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-accident/{id}/payment-schedule',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param regno 
   * @returns AccidentVehicleDto Success
   * @throws ApiError
   */
  public static getVehicleAccidentStockLookUpByRegno(
regno?: string,
): CancelablePromise<AccidentVehicleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident/stock-look-up-by-regno',
      query: {
        'regno': regno,
      },
    });
  }

  /**
   * @returns UserResultDto Success
   * @throws ApiError
   */
  public static getVehicleAccidentAccidentUsers(): CancelablePromise<UserResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-accident/accident-users',
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehicleAccidentDocuments(
id: number,
formData?: {
File: Blob;
},
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-accident/{id}/documents',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param documentId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVehicleAccidentDocuments(
id: number,
documentId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-accident/{id}/documents/{documentId}',
      path: {
        'id': id,
        'documentId': documentId,
      },
    });
  }

}
